export default {
  data() {
    /*
        these arrays contain the information for the responsive Layout
        
        they have 5 entries each for the individual breakpoints:
        [0] -> xs | [1] -> sm | [2] -> md | [3] -> lg | [4] -> xl
        */
    return {
      observedNavigationHeight: null,
      observer: null,

      navigationOrders: ["1", "1", "1", "1", "1"],
      contentOrders: ["3", "3", "3", "3", "2"],
      sortOrders: ["2", "2", "2", "2", "3"],

      navigationCols: ["12", "12", "12", "12", "3"],
      contentCols: ["12", "12", "12", "12", "6"],
      sortCols: ["12", "12", "12", "12", "3"],

      navigationPaddings: ["pa-1", "pa-1", "px-1", "px-1", "pl-1 py-1"],
      contentPaddings: ["pa-1", "pa-1", "pt-2 px-1", "pt-2 px-1", "px-2 py-1"],
      sortPaddings: ["pa-1", "pa-1", "px-1", "px-1", "pr-1 py-1"],
    };
  },

  methods: {
    adjustBreakpoints() {
      if (!this.showNav && !this.showSort) {
        this.contentCols.splice(0, 1, "12");
        this.contentCols.splice(1, 1, "12");
        this.contentCols.splice(2, 1, "11");
        this.contentCols.splice(3, 1, "7");
        this.contentCols.splice(4, 1, "5");
      }

      if (this.showNav && this.showSort) {
        this.contentCols.splice(0, 1, "12");
        this.contentCols.splice(1, 1, "12");
        this.contentCols.splice(2, 1, "12");
        this.contentCols.splice(3, 1, "12");
        this.contentCols.splice(4, 1, "6");
      }

      if (this.showNav && !this.showSort) {
        this.contentCols.splice(0, 1, "12");
        this.contentCols.splice(1, 1, "12");
        this.contentCols.splice(2, 1, "12");
        this.contentCols.splice(3, 1, "12");
        this.contentCols.splice(4, 1, "9");
      }
    },

    getCurrentBreakpoint() {
      // these are the important keys from the $vuetify.breakpoint object
      var requiredKeys = ["xs", "sm", "md", "lg", "xl"];
      // get all breakpoints from vuetify
      var breakpoints = Object.entries(this.$vuetify.breakpoint).filter((breakpoint) => {
        return requiredKeys.includes(breakpoint[0]);
      });

      // get the currently active breakpoint
      var currentBreakpoint = breakpoints.filter((breakpoint) => breakpoint[1])[0];

      return currentBreakpoint;
    },

    async navigationHeight() {
      var navigationElem = document.getElementById("layout-navigation");
      if (!navigationElem) return 0;

      await this.$nextTick();

      var navigationHeight = navigationElem.offsetHeight;
      return navigationHeight;
    },

    async searchHeight() {
      var searchElem = document.getElementById("layout-search");
      if (!searchElem) return;

      await this.$nextTick();

      var searchHeight = searchElem.offsetHeight;
      return searchHeight;
    },
    initNavAreaObserver(navigationRef) {
      const navigationArea = navigationRef, vm = this;

      // create the observer
      const observer = new ResizeObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // check if the mutation is attributes and update the width and height data if it is.
          let height = mutation.contentRect.height;
          vm.observedNavigationHeight = height;
        });
      });

      // observe navigationArea
      observer.observe(navigationArea);
      // add the observer to data so we can disconnect it later
      this.observer = observer;
    },
  },

  computed: {
    /**
     * returns an integer that indicates the current breakpoint
     * handles the states for navigation and sort
     */
    currentBreakpoint() {
      // these are the important keys from the $vuetify.breakpoint object
      var requiredKeys = ["xs", "sm", "md", "lg", "xl"];

      // get all breakpoints from vuetify
      var breakpoints = Object.entries(this.$vuetify.breakpoint).filter((breakpoint) => {
        return requiredKeys.includes(breakpoint[0]);
      });

      // get the currently active breakpoint
      var currentBreakpoint = this.getCurrentBreakpoint();
      var breakpointIndex = requiredKeys.indexOf(currentBreakpoint[0]);

      if (breakpointIndex == 4) this.adjustBreakpoints();

      // return the index of the active breakpoint
      return breakpointIndex;
    },
  },
};
